module.exports = __webpack_public_path__ + "static/media/MF2_0025_copie.6aba0a2d.webp";